import axios from 'axios';
import Authenticator from 'services/Authenticator.js';
import AuthService from 'services/AuthService';

const HTTP = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});

HTTP.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

// This allows you to intercept the response and check the status and error messages and if necessary reject the promise.
HTTP.interceptors.response.use(
    (response) => {
        return response.data;
    },
    async (error) => {
        console.error(error);
        const originalRequest = error.config;
        const token = localStorage.getItem('access_token');
        if (error.response && error.response.status === 401 && token && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const tokenResponse = await AuthService.refresh();
                const { access_token } = tokenResponse.data;
                localStorage.setItem('access_token', access_token);
                originalRequest.headers.Authorization = `Bearer ${access_token}`;
                return axios(originalRequest);
            } catch (error) {
                if (error.response.status === 401 || error.response.status === 409) {
                    Authenticator.logout();
                } else {
                    return Promise.reject(error);
                }
            }
        } else if (error.response.status === 409) {
            Authenticator.logout();
        } else {
            return Promise.reject(error);
        }
    }
);

export { HTTP };
